import React, { useEffect } from "react";
import Sidebar from "src/components/common/Sidebar";
import RodeoEventTaskPage from "src/components/events/rodeoEventGame/rodeoEventTaskPage";
import { APPLICATION_NAME, RODEO_PAGE_NAME } from "src/_config";

export default function RodeoEventTaskContainer() {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = `${APPLICATION_NAME} : Event List`;
    return () => {
      document.title = prevTitle;
    };
  }, []);

  return (
    <React.Fragment>
      <Sidebar page={RODEO_PAGE_NAME.EVENT_GAME_LIST} />
      <section className="main-container">
        <RodeoEventTaskPage />
      </section>
    </React.Fragment>
  );
}
